import type { IconName, TabButtonTab } from '@epilot/concorde-elements'
import type {
  LauncherJourney,
  LauncherJourneyTemplate
} from '@epilot/journey-logic-commons/src/types/next'

export const getLauncherTabs = (
  launcher: LauncherJourney | LauncherJourneyTemplate
) => {
  return Object.values(launcher.journeys).map<TabButtonTab>((item) => ({
    id: item.journeyId,
    // TODO: Should fetch the underlying journey names from the store/server instead
    label: item.nameOverride ?? 'fallback name',
    icon: item.icon as IconName
  }))
}
